import moment, { Moment } from 'moment';
import React, {
  useContext,
  createContext,
  useState,
  useCallback,
  useEffect,
} from 'react';
import * as storage from '../services/storage';
import { IService } from '../shared/interfaces/service-interfaces';

export interface IOrderDataState {
  customer_name: string;
  customer_whatsapp: string;
  service: IService;
  startTime: string;
  endTime: string;
  day: Moment;
}

interface OrderContextData {
  orderData: IOrderDataState;
  updateOrderData(data: Partial<IOrderDataState>): void;
}

const initialOrderState = {
  customer_name: '',
  customer_whatsapp: '',
  service: {
    id: '',
    time_box: 0,
    price: '',
    service_name: '',
  },
  startTime: '',
  endTime: '',
  day: moment(),
};

const OrderContext = createContext<OrderContextData>({} as OrderContextData);

const OrderProvider: React.FC = ({ children }) => {
  const [orderData, setOrderData] = useState<IOrderDataState>(() => {
    const orderDataState = storage.getOrderData();
    if (orderDataState) {
      return {
        ...orderDataState,
        day: moment(orderDataState.day),
      };
    }

    return initialOrderState;
  });

  const updateOrderData = useCallback(
    (data: Partial<IOrderDataState>) => {
      setOrderData({
        ...orderData,
        ...data,
      });
    },
    [orderData],
  );

  useEffect(() => {
    storage.setOrderData(orderData);
  }, [orderData]);

  return (
    <OrderContext.Provider value={{ orderData, updateOrderData }}>
      {children}
    </OrderContext.Provider>
  );
};

function useOrder(): OrderContextData {
  const context = useContext(OrderContext);

  if (!context) {
    throw new Error('useOrder must be used within a OrderProvider');
  }

  return context;
}

export { OrderProvider, useOrder };
